/**
 * @description
 * States enum
 * @enum {string}
 */
export var STATES;
(function (STATES) {
    STATES["ACTIVE"] = "ACTIVE";
    STATES["COMPLETED"] = "COMPLETED";
    STATES["DEFAULT"] = "DEFAULT";
    STATES["DEFAULT_SELECTED"] = "DEFAULT_SELECTED";
    STATES["DEFAULT_UNSELECTED"] = "DEFAULT_UNSELECTED";
    STATES["DISABLED"] = "DISABLED";
    STATES["DISABLED_SELECTED"] = "DISABLED_SELECTED";
    STATES["DISABLED_UNSELECTED"] = "DISABLED_UNSELECTED";
    STATES["ERROR"] = "ERROR";
    STATES["FILLED"] = "FILLED";
    STATES["FOCUS"] = "FOCUS";
    STATES["HOVER"] = "HOVER";
    STATES["PRESSED"] = "PRESSED";
    STATES["SELECTED"] = "SELECTED";
    STATES["LOADING"] = "LOADING";
    STATES["SUCCESS"] = "SUCCESS";
    STATES["WARNING"] = "WARNING";
    STATES["VISITED"] = "VISITED";
})(STATES || (STATES = {}));
//# sourceMappingURL=states.js.map